import React, { useEffect } from 'react';
import WorkspaceDocAccordion from './WorkspaceDocAccordion';
import { useSelector, useDispatch } from 'react-redux';
import { MotifProgressLoader } from '@ey-xd/motif-react';
import WorkspaceEditDocumentVersion from './WorkspaceEditDocumentVersion';
import WorkspaceVersionDocumentUpload from './WorkspaceVersionDocumentUpload';

const WorkspaceDocs = () => {
  const dispatch = useDispatch();
  const { workspaceDocuments, inProgress, workspaceOverview } = useSelector((state: any) => state.workspaces);

  useEffect(() => {
    dispatch({
      type: 'GET_WORKSPACE_DOCUMENTS',
      payload: {
        workspaceId: workspaceOverview.workSpaceId
      }
    });
  }, [inProgress]);

  const docs = [...workspaceDocuments];
  docs.sort((a, b) => a.documentId - b.documentId);

  if (!workspaceDocuments) return <p>Loading ...</p>;
  return (
    <div>
      <MotifProgressLoader
        aria-busy="true"
        aria-label="This page is loading"
        aria-live="polite"
        arialabel="This page is loading"
        fullscreen
        role="alertdialog"
        show={inProgress}
        size="xl"
        tip="Loading..."
        variant="circular"
      />
      <div className="flex flex-col gap-3">
        <h3>Below listed are your supporting document, click to view its versions and also to upload a new version:</h3>
        <div>{docs && docs.map((doc: any, index: number) => <WorkspaceDocAccordion {...doc} key={index} />)}</div>
      </div>
      <WorkspaceEditDocumentVersion />
      <WorkspaceVersionDocumentUpload />
    </div>
  );
};

export default WorkspaceDocs;
